import type {StateProvider, Transition} from '@uirouter/angularjs';
import inventoriesTemplate from './inventories-page/inventories.tpl.ftl';
import matchesTemplate from './matches-page/matches.tpl.ftl';
import capturesTemplate from './captures-page/captures.tpl.ftl';
import {InventoriesController} from './inventories-page/inventories.controller';
import {KpSvelteComponentWrapperComponent} from 'core/kp-svelte-component-wrapper/kp-svelte-component-wrapper.component';
import type {InventoryDataService} from './inventory.data-service';
import {CapturesController} from './captures-page/captures.controller';
import {MatchesController} from './matches-page/matches.controller';
import type {InventoryDetailViewConfiguration} from './types';

export const INVENTORY_DETAIL_VIEW_CONFIGURATION = 'inventory-detail-view-configuration';

/*@ngInject*/
export function inventoryRoutes($stateProvider: StateProvider) {
    $stateProvider
        .state('inventories', {
            url: '/inventories',
            controller: InventoriesController,
            templateUrl: inventoriesTemplate,
            controllerAs: '$ctrl'
        });

    $stateProvider
        .state('captures', {
            url: '/inventories/:inventoryId/captures',
            controller: CapturesController,
            templateUrl: capturesTemplate,
            controllerAs: '$ctrl',
            resolve: {
                /*@ngInject*/
                inventory: (inventoryDataService: InventoryDataService, $transition$: Transition) => inventoryDataService.getInventory($transition$.params().inventoryId)
            }
        });

    $stateProvider
        .state('matches', {
            url: '/inventories/:inventoryId/matches',
            controller: MatchesController,
            templateUrl: matchesTemplate,
            controllerAs: '$ctrl',
            resolve: {
                /*@ngInject*/
                inventory: (inventoryDataService: InventoryDataService, $transition$: Transition) => inventoryDataService.getInventory($transition$.params().inventoryId)
            }
        });

    let inventoryModule: { default: any; };
    $stateProvider
        .state({
            name: 'inventory',
            url: '/inventories/:inventoryId',
            component:  KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => inventoryModule.default,
                /*@ngInject*/
                props: async (inventoryDataService: InventoryDataService, $transition$: Transition) => {
                    const inventory = await inventoryDataService.getInventory($transition$.params().inventoryId);
                    return {inventory};
                },
                /*@ngInject*/
                additionalContext: async (inventoryDataService: InventoryDataService, $transition$: Transition) => {
                    const detailViewConfiguration = await inventoryDataService.getDetailViewConfiguration($transition$.params().inventoryId);
                    return new Map<string, InventoryDetailViewConfiguration>([[INVENTORY_DETAIL_VIEW_CONFIGURATION, detailViewConfiguration]]);
                }

            },
            lazyLoad: async () => {
                inventoryModule = await import(/* webpackChunkName: "inventory" */ './inventory-page/KpInventory.svelte');
                return null;
            }
        });
}